// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3xSEE","container":"styles_container__2Yeah","title":"styles_title__3VQnf","wrapper":"styles_wrapper__FQJgT","answer":"styles_answer__3wPFj"};